import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Link} from "react-router-dom";
import {push} from "react-router-redux";
import CreativeTaskForm from "../../../common/creative-task-form";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";
import {submitCreativeTask} from "game/app/actions/creative-tasks-actions";
import assets from "game/app/assets";
import GameInstance from "common/models/game-instance";
import VideoBtn from "game/app/components/video-btn";

class Categories extends GameComponent {

    constructor(props) {
        super(props);
        this.state = { instanceId: null, lifeModalOpened: false }
    }

    componentWillMount() {
        const instanceId = this.props.gameInstance.instance.id;
        this.setState({...this.state, instanceId: instanceId});
    }

    hideModal = () => {
        this.setState({...this.state, lifeModalOpened: false })
    };

    toggleLifeModal = () => {
        this.props.sendInput(this.getInstanceId(), { type: 'life_enter' }).then(() => {
            this.setState({...this.state, lifeModalOpened: false});
            this.props.push(`/game/${this.getInstanceId()}/round-2/co-zivot-dal`);

        });
    };

    enterLife = () => {
        this.setState({...this.state, lifeModalOpened: true });
    };

    submitCreativeTask = (task) => {
        return (values, form) => {
            this.props.submitCreativeTask(this.getInstanceId(), task.id, values)
        }
    };

    renderCategory(category_id, about) {
        let list = this.props
            .knowledgeQuestions
            .list
            .filter((item) => { return item.properties.category === category_id });

        let questionIds = new Set();

        list.forEach((item) => {
            questionIds.add(item.id);
        });

        let categoryAnswers = this.props.gameInstance.instance.answers.filter((item) => {
            return questionIds.has(item.luduengine_knowledge_question_id);
        });

        let btnClass = 'btn btn-block ';
        btnClass += (categoryAnswers.length === list.length ? 'btn-success ' : 'btn-primary ');
        if ( this.getInstanceProperty('ROUND_2_LIFE_ENTERED') && !this.getInstanceProperty('ROUND_2_COMPLETED_LIFE') ) {
            btnClass += ' disabled';
        }

        return (
            <div className='col-md-6 col-lg-4 text-center separate-bottom-grid'>
                <div className='card aligned-card'>
                    <div className='card-body'>
                        <img src={assets['categories'][category_id]} className='img-fluid'/>
                        <h5>{GameInstance.getCategoryTitle(category_id)}</h5>
                        <p className='fill'>{ about }</p>
                        <p>Základní úkoly { categoryAnswers.length } / { list.length }</p>
                        <Link to={`/game/${this.props.gameInstance.instance.id}/round-2/otazky/${category_id}`} className={btnClass}>Zobrazit</Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.knowledgeQuestions.loading) {
            return (<div>Loading</div>);
        }

        let basicComplete = this.getInstanceProperty('ROUND_2_COMPLETED_BASIC');
        let lifeComplete = this.getInstanceProperty('ROUND_2_COMPLETED_LIFE');
        let lifeEntered = this.getInstanceProperty('ROUND_2_LIFE_ENTERED');
        let roundCompleted = this.getInstanceProperty('ROUND_2_COMPLETED');
        let creativeTasks = this.props.creativeTasks.list
            .filter((task) => task.node === 'Nodes::Round02Node')
            .map((task) => (<CreativeTaskForm key={task.id} resource={task} handleSubmit={this.submitCreativeTask(task)} active={!roundCompleted}/>));

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <div className='separate-bottom text-center'>
                            <h1 className='page-title-minor separate-bottom'>Úkoly</h1>
                            <p>Úkoly jsou rozděleny do několika kategorií. Po jejím rozkliknutí se vám zobrazí jednotlivé otázky.</p>
                            <p>Podívejte se na různe typy výdajů v našem videu, bude se vám rozhodovat lépe.</p>
                            <div><VideoBtn videoId='1j14hiDSyc8'/></div>
                        </div>
                        <p className='label'>Kategorie základních úkolů</p>
                        <div className='row aligned-lg'>
                            { this.renderCategory('domacnost', 'Vyberte si, jak se budete starat o svou domácnost a jak ji vybavíte.') }
                            { this.renderCategory('pece_o_sebe', 'Je potřeba se starat nejen o domácnost, ale i o sebe.') }
                            { this.renderCategory('komunikace_a_media', 'Vyberte si telefon, tarif, počítač a další vybavení, které budete používat.') }
                            { this.renderCategory('zdravi_a_sport', 'Rozmyslete si, jak se budete udržovat fit a nastavte si to v této kategorii.') }
                            { this.renderCategory('vzdelavani_a_rozvoj', 'Budou děti chodit na kroužky? A budou se dále vzdělávat i dospělí členové domácnosti?') }
                            { this.renderCategory('pece_o_zvire', 'Budou děti chodit na kroužky? A budou se dále vzdělávat i dospělí členové domácnosti?') }
                            { this.renderCategory('zabava','Vyražte si občas ven. Bude to bavit dospělé i děti a zvedne vám to náladu.') }
                            <div className='col-lg-8 text-center'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <img src={assets['categories']['co_zivot_dal']} className='img-fluid'/>
                                        <h5>{GameInstance.getCategoryTitle('co_zivot_dal')}</h5>
                                        <p>V okamžiku, kdy máte nastavené výdaje ve všech kategoriích výše, můžete si vyzkoušet, co na vás přichystal život. Ale pozor, pokud se do toho pustíte, nebudete se už moct vrátit zpátky a změnit své dřívější odpovědi.</p>
                                        { basicComplete && lifeComplete && <Link to={`/game/${this.props.gameInstance.instance.id}/round-2/co-zivot-dal`} className='btn btn-success btn-block'>Změřit síly se životem</Link> }
                                        { basicComplete && !lifeComplete && !lifeEntered && <button onClick={this.enterLife} className='btn btn-primary btn-block'>Změřit síly se životem</button> }
                                        { basicComplete && !lifeComplete && lifeEntered && <Link to={`/game/${this.props.gameInstance.instance.id}/round-2/co-zivot-dal`} className='btn btn-primary btn-block'>Změřit síly se životem</Link> }
                                        { !basicComplete && <span className='btn btn-secondary btn-block disabled'>Změřit síly se životem</span> }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <p className='label'>Kreativní úkoly</p>
                        { creativeTasks }
                        <Modal isOpen={this.state.lifeModalOpened} modalTransition={{ timeout: 200 }} backdropTransition={{ timeout: 200 }} className={this.props.className}>
                            <ModalHeader toggle={this.toggle} className='text-center'>Jdete si vyzkoušet život</ModalHeader>
                            <ModalBody>
                                <p>Pokud budete pokračovat, nebudete se už moct vrátit zpátky k vašim dřívějším odpovědím a změnit, jak máte nastavený rozpočet. Opravdu chcete pokračovat?</p>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" onClick={this.toggleLifeModal} className={'test'}>Ano, jdeme na to</Button> <Button color="secondary" onClick={this.hideModal}>Ne, chceme se vrátit</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        creativeTasks: state.creativeTasks
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        submitCreativeTask: submitCreativeTask,
        push: push
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Categories);
